{
    "product_information__id__product_id": "Art.-Nr. {{value}}",
    "product_information__id__purchase_order_number": "Herstellernr. {{value}}",
    "product_information__id__ean": "EAN {{value}}",
    "product_information__id__gtin": "GTIN {{value}}",
    "description": "Beschreibung",
    "recommendations": "Oft zusammen gekauft",
    "recommendations__tooltip": "Komplementäre Artikel, die oft zusammen gewählt werden.",
    "variants": "Varianten",
    "info_block_title__product_group": "Produktgruppe",
    "info_block_title__supplier": "Lieferant",
    "info_block_title__total_availability": "Gesamtverfügbarkeit",
    "info_block_title__packaging": "Verpackung",
    "tab_title__info": "Artikelinformationen",
    "tab_title__availability": "Bestand",
    "tab_title__quotes": "Angebote",
    "tab_title__orders": "Aufträge",
    "tab_title__explorer": "Umsatzanalyse",
    "quick_add": "Hinzufügen",
    "table_header__total_tooltip": "Kann durch Rabatte auf Positionsebene vom Einzelpreis × Menge abweichen.",
    "table_header__item_id": "Artikel-Nr.",
    "table_header__item_name": "Artikel",
    "search_placeholder": "Suche nach Artikel"
}
